import React, { useState, useContext, useEffect } from 'react';
import { motion } from 'framer-motion';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { isEmpty } from 'lodash';
import { Link } from 'gatsby';
import Icons from '../layouts/Icons';
import MobileHeaderMenu from './MobileHeaderMenu';
import useScroll from '../../hooks/useScroll';
import useMediaQuery from '../../hooks/useMediaQuery';
import { GlobalContext } from '../../context/GlobalContext';

export default function MobileHeader({ data }) {
  const { lightLogo, darkLogo, mobileNavigation } = data;
  const windowGlobal = typeof window !== 'undefined' && window;
  const [isOpen, setIsOpen] = useState();
  const [position, setPosition] = React.useState(0);
  const [visible, setVisible] = React.useState(true);
  const { cssClass } = useContext(GlobalContext);
  const darkHeader = cssClass.includes('dark-header');
  const logo = darkHeader && position <= 115 ? darkLogo : lightLogo;

  const handleScroll = () => {
    const moving = windowGlobal.window.pageYOffset <= 115 ? 0 : windowGlobal.window.pageYOffset;
    setVisible(position > moving || moving === 0);
    setPosition(moving);
  };

  React.useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  });

  const isDesktop = useMediaQuery('(min-width: 992px)');
  const handleClick = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    if (isDesktop) {
      setIsOpen(false);
    }
  }, [isDesktop]);

  return (
    <>
      <div
        className={`lg:hidden flex justify-between items-center gap-x-8 z-100 transition-all
        duration-300 fixed w-full px-6  before:content-[''] before:!inline before:absolute
        before:top-0 before:left-0 before:h-5 before:w-full before:bg-black h-[120px]
        ${visible ? 'translate-y-0' : '-translate-y-[100%]'}
        ${position <= 115 ? 'bg-transparent' : 'bg-bg-7'}
        ${isOpen ? 'bg-red' : ''}`}
      >
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3, delay: 0.3 }}
          className="overflow-hidden"
        >
          {isEmpty(logo) || (
            <Link to="/">
              <LazyLoadImage src={logo.url} className="object-contain w-[165px] h-auto pt-[20px]" />
            </Link>
          )}
        </motion.div>
        <motion.button
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3, delay: 0.2 }}
          type="button"
          onClick={handleClick}
          aria-label="menu-button"
          className={`mt-[1.25rem]
          ${isOpen ? 'bg-white h-[40px] w-[40px]' : 'bg-red h-[40px] w-[40px]'}`}
        >
          <Icons
            icon={isOpen ? 'close' : 'menu'}
            className={
              isOpen
                ? '!inline-block fill-white w-[15px] h-[15px] -mt-[3px]'
                : '!inline-block fill-white -mt-[3px]'
            }
          />
        </motion.button>
      </div>
      <MobileHeaderMenu data={mobileNavigation} isOpen={isOpen} />
    </>
  );
}
